var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ui-tabs__wrap"},[_c('div',{ref:"tabsContainer",staticClass:"ui-tabs"},[_c('div',{staticClass:"ui-tabs__slider",style:(_setup.sliderStyle)}),_vm._l((_setup.props.tabs),function(tab,index){return _c('button',{key:tab.value,ref:(el) => { _setup.buttonRefs[index] = el; },refInFor:true,class:[
                'ui-tabs__tab',
                `--${_setup.props.size}`,
                { '--active': _setup.props.modelValue === tab.value }
            ],attrs:{"disabled":tab.disabled},on:{"click":function($event){return _setup.selectTab(tab.value)}}},[_vm._v(" "+_vm._s(tab.text)+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }